__turbopack_context__.v({
  "root": "ContextualPopupSection-module__CDVv1W__root",
});
